import {i18n} from '../../../boot/i18n'

export default function () {
  return {
    catalogOptions: {
      filters: {
        values: [],
      },
      sortOptions: [],
    },
    selectedSort: {
      french: i18n.t('catalogPage.sortTypeDefault'),
      option: 'master',
    },
    searchValue: '',
    userVersions: [],
    newSongs: [],
    challenges: {
      d0: null,
      d1: null,
      d2: null,
      d3: null,
      d4: null,
      completed_count: 0,
      count: 0,
    },
    maxPage: 1,
    filteredSongs: null,
    lastFilteredSongsParameters: null,
    currentSearchPromiseKey: null,
    currentPage: 1,
    pageQty: 1,
  };
}
